export default "__VITE_ASSET__59d5f887__"